import React from "react";
import { Form } from "semantic-ui-react";
import { useTranslation } from "ceco-polyglot";
import graphql from "babel-plugin-relay/macro";

import { createFragmentContainer } from "react-relay";

import "./dropdownUsers.scss";

const DropdownUsers = ({
  formErrors,
  handleChangeUser,
  formData,
  allUsers: { edges },
}) => {
  const t = useTranslation();
  const users = edges.map((user) => {
    const {
      node: { id, username },
    } = user;
    return {
      key: id,
      text: username,
      value: id,
    };
  });

  return (
    <Form.Dropdown
      placeholder={t("form.createdBy")}
      label={t("form.createdBy")}
      name="author"
      search
      onChange={handleChangeUser}
      defaultValue={formData?.author?.toString() || ""}
      noResultsMessage={t("message.noResultsUsers")}
      selection
      options={users}
      clearable
    />
  );
};

export default createFragmentContainer(DropdownUsers, {
  allUsers: graphql`
    fragment DropdownUsers_allUsers on UserNodeConnection {
      edges {
        node {
          id
          username
          firstName
          lastName
        }
      }
    }
  `,
});
